import { isMobileOnly } from 'react-device-detect';
import styled from 'styled-components';

export const Container = styled.div`
  max-width: ${isMobileOnly ? '95vw' : '1100px'};
  background: transparent;
  margin: 0px auto;
  padding: ${isMobileOnly ? '10px' : '30px'};
`;

export const AdsGrid = styled.div`
  display: grid;
  grid-template-columns: ${isMobileOnly ? '1fr' : 'repeat(3, 1fr)'};
  gap: 20px;
  margin-top: 20px;
`;

export const AdCard = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }
`;

export const AdCardImage = styled.div`
  width: 100%;
  height: 200px;
  background-color: #f0f0f0;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AdCardContent = styled.div`
  padding: 16px;
`;

export const CategoryChip = styled.span`
  display: inline-block;
  background-color: ${(props) => props.color || '#e0e0e0'};
  color: ${(props) => props.textColor || '#333'};
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
`;

export const FilterChip = styled.button`
  background-color: ${(props) => (props.active ? props.activeColor || '#1976d2' : 'transparent')};
  color: ${(props) => (props.active ? '#fff' : '#666')};
  border: 1px solid ${(props) => (props.active ? props.activeColor || '#1976d2' : '#d0d0d0')};
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;

  &:hover {
    background-color: ${(props) => (props.active ? props.activeColor || '#1976d2' : '#f0f0f0')};
  }
`;

export const DetailContainer = styled.div`
  max-width: ${isMobileOnly ? '95vw' : '900px'};
  background: transparent;
  margin: 0px auto;
  padding: ${isMobileOnly ? '10px' : '30px'};
`;

export const DetailCard = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const DetailImageCarousel = styled.div`
  width: 100%;
  height: ${isMobileOnly ? '250px' : '400px'};
  position: relative;
  background-color: #f0f0f0;
`;

export const CarouselImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CarouselButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(props) => (props.direction === 'left' ? 'left: 10px;' : 'right: 10px;')}
  background: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  &:hover {
    background: rgba(255, 255, 255, 1);
  }
`;

export const DetailContent = styled.div`
  padding: ${isMobileOnly ? '16px' : '24px'};
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const UserAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background-color: #e0e0e0;
`;

export const CommentSection = styled.div`
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #eee;
`;

export const CommentItem = styled.div`
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
`;

export const CommentInput = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
  align-items: flex-start;
`;

export const NoImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 48px;
`;
